import { all, takeEvery } from "redux-saga/effects";
import { PdApiActionsEnum } from "../actions/pdApiActions";
import {
  fetchDataSaga,
  fetchParametersSaga,
  fetchFaultsSaga,
  fetchSignalsSaga,
  fetchEscalatorRTDs,
  fetchEscalatorRTDGroups,
  fetchEscalatorEventLogs,
  fetchStandardBoardsShallowSaga,
  fetchIoConfigurations,
  fetchSingleSaga,
  downloadLocalizationFilesSaga,
  publishLocalizationFilesSaga,
  convertBinaryIoConfigToStringSaga,
  exportDevelopmentPackageSaga,
  fetchChartDataSaga,
  fetchTranslationLogItemsSaga,
  generateLicenseDataSaga,
  generateEscalatorLicenseDataSaga,
  generateDoorLicenseDataSaga,
  fetchEscalatorParameters,
  fetchEscalatorFaults,
  fetchAllOnClickSaga,
  fetchAPMParamters,
  fetchAPMFaults,
  fetchEscalatorEvent,
  fetchEscalatorVersions,
  fetchDoorBindings,
  fetchDoorEvent,
  fetchDriveFaults,
  fetchLiftaults,
  fetchGroupFaults,
  fetchSignalizationFaults,
  fetchNetworkFaults,
  fetchMonitoringFaults,
  fetchMonitoringFaultCategories,
  fetchDriveParameters,
  fetchDataActCodes,
  downloadEscalatorDevPackageSaga,  
  fetchEscalatorDataActCodes,
  fetchGrandNorms,
  uploadToTlgQaSaga,
  fetchLicenseRecordSaga,
  pushToProdSaga,
  requestLotaSaga,
  approveLotaSaga,
  rejectLotaSaga,
} from "./pdApiSagas";
import { EditActionsEnum } from "../actions/editActions";

import {
  addSaga,
  updateSaga,
  startEditingSaga,
  selectSaga,
  selectParentSaga,
  deleteSaga,
  updateParametersSaga,
  updateEscalatorBindingsSaga,
  updateEscalatorFaultBindingsSaga,
  cancelEditingSaga,
  addActionSaga,
  addNodeSaga,
  deleteByIdSaga,
  addTranslationsSaga,
  updateDoorBindingsSaga,
  updateLiftBindingsSaga
} from "./editSagas";
export default function* rootSaga(): Api.AnyItem {
  yield all([
    takeEvery(PdApiActionsEnum.FETCH_DATA, fetchDataSaga),
    takeEvery(PdApiActionsEnum.FETCH_PARAMETERS, fetchParametersSaga),
    takeEvery(PdApiActionsEnum.FETCH_FAULTS, fetchFaultsSaga),
    takeEvery(PdApiActionsEnum.FETCH_SIGNALS, fetchSignalsSaga),
    takeEvery(PdApiActionsEnum.FETCH_ESCALATOR_RTDs, fetchEscalatorRTDs),
    takeEvery(PdApiActionsEnum.FETCH_ESCALATOR_RTD_GROUPS, fetchEscalatorRTDGroups),
    takeEvery(PdApiActionsEnum.FETCH_ESCALATOR_EVENT_LOGS, fetchEscalatorEventLogs),
    takeEvery(PdApiActionsEnum.FETCH_SINGLE, fetchSingleSaga),
    takeEvery(PdApiActionsEnum.FETCH_CHARTDATA, fetchChartDataSaga),
    takeEvery(PdApiActionsEnum.FETCH_TRANSLATION_LOG_ITEMS, fetchTranslationLogItemsSaga),
    takeEvery(PdApiActionsEnum.DOWNLOAD_LOCALIZATION_FILE, downloadLocalizationFilesSaga),
    takeEvery(PdApiActionsEnum.PUBLISH_LOCALIZATION_FILES, publishLocalizationFilesSaga),
    takeEvery(PdApiActionsEnum.EXPORT_DEVELOPMENT_PACKAGE, exportDevelopmentPackageSaga),
    takeEvery(PdApiActionsEnum.DOWNLOAD_ESCALATOR_DEV_PACKAGE, downloadEscalatorDevPackageSaga),
    takeEvery(
      PdApiActionsEnum.CONVERT_BINARY_IOCONFFIG_TO_STRING,
      convertBinaryIoConfigToStringSaga
    ),
    takeEvery(PdApiActionsEnum.GENERATE_LICENSE_DATA, generateLicenseDataSaga),
    takeEvery(PdApiActionsEnum.GENERATE_ESCALATOR_LICENSE_DATA, generateEscalatorLicenseDataSaga),
    takeEvery(PdApiActionsEnum.GENERATE_DOOR_LICENSE_DATA, generateDoorLicenseDataSaga),
    takeEvery(PdApiActionsEnum.FETCH_STANDARD_BOARDS_SHALLOW, fetchStandardBoardsShallowSaga),
    takeEvery(PdApiActionsEnum.FETCH_IO_CONFIGURATIONS_SHALLOW, fetchIoConfigurations),
    takeEvery(PdApiActionsEnum.FETCH_ESCALATOR_PARAMETERS, fetchEscalatorParameters),
    takeEvery(PdApiActionsEnum.FETCH_APM_PARAMETERS, fetchAPMParamters),
    takeEvery(PdApiActionsEnum.FETCH_APM_FAULTS, fetchAPMFaults),
    takeEvery(PdApiActionsEnum.FETCH_SIGNALIZATION_FAULTS, fetchSignalizationFaults),
    takeEvery(PdApiActionsEnum.FETCH_DRIVE_FAULTS, fetchDriveFaults),
    takeEvery(PdApiActionsEnum.FETCH_LIFT_FAULTS, fetchLiftaults),
    takeEvery(PdApiActionsEnum.FETCH_GROUP_FAULTS, fetchGroupFaults),
    takeEvery(PdApiActionsEnum.FETCH_NETWORK_FAULTS, fetchNetworkFaults),
    takeEvery(PdApiActionsEnum.FETCH_ESCALATOR_FAULTS, fetchEscalatorFaults),
    takeEvery(PdApiActionsEnum.FETCH_ESCALATOR_EVENT_CLASSES, fetchEscalatorEvent),
    takeEvery(PdApiActionsEnum.FETCH_ESCALATOR_VERSIONS, fetchEscalatorVersions),
    takeEvery(PdApiActionsEnum.FETCH_DOOR_BINDINDS, fetchDoorBindings),
    takeEvery(PdApiActionsEnum.FETCH_DOOR_EVENT_CLASSES, fetchDoorEvent),
    takeEvery(PdApiActionsEnum.FETCH_DRIVE_PARAMETERS, fetchDriveParameters),
    takeEvery(PdApiActionsEnum.FETCH_MONITORING_FAULTS, fetchMonitoringFaults),
    takeEvery(PdApiActionsEnum.FETCH_MONITORING_FAULT_CATEGORIES, fetchMonitoringFaultCategories),
    takeEvery(PdApiActionsEnum.FETCH_ALL_ON_CLICK, fetchAllOnClickSaga),
    takeEvery(EditActionsEnum.ADD_OBJECT, addSaga),
    takeEvery(EditActionsEnum.UPDATE_OBJECT, updateSaga),
    takeEvery(EditActionsEnum.ADD_ACTION, addActionSaga),
    takeEvery(EditActionsEnum.ADD_NODE, addNodeSaga),
    takeEvery(EditActionsEnum.UPDATE_PARAMETERS, updateParametersSaga),
    takeEvery(EditActionsEnum.UPDATE_ESCALATOR_BINDINGS, updateEscalatorBindingsSaga),
    takeEvery(EditActionsEnum.UPDATE_ESCALATOR_FAULT_BINDINGS, updateEscalatorFaultBindingsSaga),
    takeEvery(EditActionsEnum.UPDATE_BINDINGS, updateDoorBindingsSaga),
    takeEvery(EditActionsEnum.UPDATE_LIFT_BINDINGS, updateLiftBindingsSaga),
    takeEvery(EditActionsEnum.DELETE_OBJECT, deleteSaga),
    takeEvery(EditActionsEnum.DELETE_BY_ID, deleteByIdSaga),
    takeEvery(EditActionsEnum.SELECT_OBJECT, selectSaga),
    takeEvery(EditActionsEnum.SELECT_PARENT, selectParentSaga),
    takeEvery(EditActionsEnum.START_EDITING_OBJECT, startEditingSaga),
    takeEvery(EditActionsEnum.CANCEL_EDITING_OBJECT, cancelEditingSaga),
    takeEvery(EditActionsEnum.ADD_TRANSLATIONS, addTranslationsSaga),
    takeEvery(PdApiActionsEnum.FETCH_DATA_ACT_CODES, fetchDataActCodes),
    takeEvery(PdApiActionsEnum.FETCH_ESCALATOR_DATAACT_CODES, fetchEscalatorDataActCodes),
    takeEvery(PdApiActionsEnum.FETCH_GRAND_NORMS, fetchGrandNorms),
    takeEvery(PdApiActionsEnum.UPLOAD_TLG_QA, uploadToTlgQaSaga),
    takeEvery(PdApiActionsEnum.FETCH_LICENSE_RECORD, fetchLicenseRecordSaga),
    takeEvery(PdApiActionsEnum.PUSH_TO_PROD, pushToProdSaga),
    takeEvery(PdApiActionsEnum.REQUEST_LOTA, requestLotaSaga),
    takeEvery(PdApiActionsEnum.APPROVE_LOTA, approveLotaSaga),
    takeEvery(PdApiActionsEnum.REJECT_LOTA, rejectLotaSaga)
  ]);
}
